import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonModuleP8} from '@Common/common-p8.module';
import {FlexLayoutModule} from '@Common/widgets/flex-layout/flex-layout.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAngularModule} from '@Common/mat-angular.module';
import {RouterModule} from '@angular/router';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {TreeComponent} from '../page/tree/tree.component';

@NgModule({
    /* Modules */
    imports: [
        CommonModule,
        CommonModuleP8,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatAngularModule,
        ReactiveFormsModule,
        MatGridListModule,
        MatInputModule,
        MatFormFieldModule,
        RouterModule,
    ],
    exports: [
        TreeComponent
    ],
    declarations: [
        TreeComponent
    ],
    providers: []
})
export class CommonBdcModule {
  constructor() {}

}
